// extracted by mini-css-extract-plugin
export default {"l":"_5e3dd73e26"};